import { render } from "./IntroductionCard.vue?vue&type=template&id=51397afa&scoped=true"
import script from "./IntroductionCard.vue?vue&type=script&lang=js"
export * from "./IntroductionCard.vue?vue&type=script&lang=js"

import "./IntroductionCard.vue?vue&type=style&index=0&id=51397afa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51397afa"]])

export default __exports__